<template>
  <div>
    <div class="loader">
      <div class="loader-inner ball-scale">
        <div></div>
      </div>
    </div>
    <div class="loader-text" style="color: #279fcf">正在加载中...</div>
  </div>
</template>

<script>
import { userLogin } from '@/api';
import { Toast } from 'mint-ui';

export default {
    name: 'auth',
    created(){
      // 获取code
      if (this.$route.query.code) {
        this.userlogin()
      } else {
        let url = sessionStorage.getItem("beforeUrl");
        this.$router.push({path: url})
      }
    },
    methods: {
      // 用户登录接口
      userlogin() {
        let uid = sessionStorage.getItem("cww_unite_uid");
        userLogin({'code': this.$route.query.code, user_id: uid || ''}).then(res => {
        // userLogin({'code': this.$route.query.code}).then(res => {
          if (res.code === 0) {
            localStorage.setItem('cww_data', JSON.stringify(res.data));
            let url = sessionStorage.getItem("beforeUrl");
            this.$router.push({path: url})
          } else {
            Toast({message: res.msg, className: 'iconfont icon-close', duration: 1500});
            // setTimeout(res => {
            //   this.$router.push({name: url})
            // }, 1500)
          }
        })
      },
    }
}
</script>

